module.exports = __webpack_public_path__ + "static/media/hotmart.1a164166.png";